import { Component, Input } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';

@Component({
  selector: 'app-textarea',
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
})
export class TextareaComponent {
  @Input()
  appearance?: 'fill' | 'outline' = 'outline';
  
  @Input()
  label: string = '';

  @Input()
  name: string = '';

  @Input()
  icon?: string = '';

  constructor() {}
}
